import { useMemo } from "react";
import { getDatesBetween } from "@/shared/utils/getDatesBetween";
import type { WorkerRow } from "../types";
import { buildWorkerRowsFromByStaff } from "../utils/attendance.utils";
import { useDailyAttendanceByStaff } from "./useDailyAttendance";

export function useAttendanceTableData(
	organizationId: string,
	organizationName: string,
	startDate: string,
	endDate: string
) {
	const { data: byStaffItems, isLoading } = useDailyAttendanceByStaff(
		organizationId,
		startDate,
		endDate
	);

	const days = useMemo(() => {
		return getDatesBetween(new Date(startDate), new Date(endDate));
	}, [startDate, endDate]);

	const tableData = useMemo((): WorkerRow[] => {
		if (!byStaffItems) {
			return [];
		}
		return buildWorkerRowsFromByStaff(byStaffItems, organizationName, organizationId);
	}, [byStaffItems, organizationName, organizationId]);

	return { tableData, days, isLoading };
}
